export enum FeatureFlags {
    VERSAPAY = 'versapay',
    CONSERVICE = 'conservice',
    CONVERSATIONS = 'conversations',
    ORBIPAY = 'orbipay',
}
